/**
 * Saves the selected company details into localStorage.
 * @param selectedOption - The company option selected by the user.
 */
export const handleCompanySelection = (
  selectedOption: any,
  setSelectedCompanyOption: any
) => {
  if (!selectedOption) return;

  const newFormData = {
    company_id: selectedOption?.value,
    company_name: selectedOption?.label?.split("-")[0]?.trim() || "",
    company_type: selectedOption?.label?.split("-")[1]?.trim() || "",
  };

  setSelectedCompanyOption((prev: any) => ({
    ...prev,
    ...newFormData,
  }));

  localStorage.setItem("selectedERSCompany", JSON.stringify(newFormData));
};

/**
 * Converts company objects into dropdown option objects.
 * @param companies - List of companies from API.
 * @returns Array of option objects with value, label, and companyName.
 */
export const getCompanyOptions = (
  companies: any[]
): {
  value: string;
  label: string;
  companyName: string;
}[] => {
  return companies.map((company) => ({
    value: company?.id?.toString(),
    label: `${company?.name} - ${company?.type ?? ""}`,
    companyName: company?.name,
  }));
};
